var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap", attrs: { id: "app" } },
    [
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "loading-bg"
        },
        [_c("loading-bar")],
        1
      ),
      _vm.isLogin
        ? _c("auto-logout", {
            on: {
              logout: function($event) {
                _vm.autoLogout = true
              }
            }
          })
        : _vm._e(),
      _c("modal-pop", {
        attrs: {
          opened: _vm.autoLogout,
          "no-negative-button": true,
          confirm: "MCOM-0000093",
          cancel: "MCOM-0000003"
        },
        on: {
          "update:opened": function($event) {
            _vm.autoLogout = $event
          },
          confirm: function() {
            _vm.$router.push({ name: "login" })
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _c("strong", { staticClass: "text-info" }, [
                    _vm._v(
                      _vm._s(/*로그아웃 되었습니다.*/ _vm.$t("MCOM-0000095"))
                    )
                  ]),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.$t("MCOM-0000096")) }
                  })
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("modal-pop", {
        attrs: {
          opened: _vm.needLoginModalOpended,
          "no-negative-button": true,
          confirm: "MCOM-0000003",
          cancel: "MCOM-0000094"
        },
        on: {
          "update:opened": function($event) {
            _vm.needLoginModalOpended = $event
          },
          confirm: _vm.goLogin,
          cancel: function() {
            ;(_vm.needLoginPath = ""),
              _vm.$router.push({
                name: "main",
                params: { siteCode: this$1.siteCode, lang: this$1.lang }
              })
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _c("strong", {
                    staticClass: "text-info",
                    domProps: { innerHTML: _vm._s(_vm.$t("MCOM-0000105")) }
                  })
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("error-modal"),
      _c("fido"),
      _c("router-view"),
      _c("permission-popup", { ref: "permission" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }